
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X, ChevronDown } from "lucide-react";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <img 
                src="/lovable-uploads/719484f4-0730-46ce-81b1-42c4a08b3b01.png" 
                alt="Way2Learn Driving School" 
                className="h-16 mr-2" 
              />
            </Link>
            <div className="hidden md:ml-6 md:flex md:space-x-8">
              <Link
                to="/"
                className="inline-flex items-center px-1 pt-1 text-sm font-medium text-road-900 hover:text-drivewise-600 border-b-2 border-transparent hover:border-drivewise-500"
              >
                Home
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center px-1 pt-1 text-sm font-medium text-road-900 hover:text-drivewise-600 border-b-2 border-transparent hover:border-drivewise-500"
              >
                About Us
              </Link>
              <Link
                to="/instructors"
                className="inline-flex items-center px-1 pt-1 text-sm font-medium text-road-900 hover:text-drivewise-600 border-b-2 border-transparent hover:border-drivewise-500"
              >
                Instructors
              </Link>
              <Link
                to="/student-gallery"
                className="inline-flex items-center px-1 pt-1 text-sm font-medium text-road-900 hover:text-drivewise-600 border-b-2 border-transparent hover:border-drivewise-500"
              >
                Student Gallery
              </Link>
              <Link
                to="/faq"
                className="inline-flex items-center px-1 pt-1 text-sm font-medium text-road-900 hover:text-drivewise-600 border-b-2 border-transparent hover:border-drivewise-500"
              >
                FAQ
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center px-1 pt-1 text-sm font-medium text-road-900 hover:text-drivewise-600 border-b-2 border-transparent hover:border-drivewise-500"
              >
                Contact
              </Link>
            </div>
          </div>
          <div className="hidden md:flex items-center space-x-4">
            <Button asChild className="bg-green-600 hover:bg-green-700 text-white">
              <Link to="/book-driving-lesson">Book Driving Lesson</Link>
            </Button>
            <div className="relative">
              <button
                onClick={toggleDropdown}
                className="flex items-center text-sm font-medium text-road-900 hover:text-drivewise-600 focus:outline-none"
              >
                Login
                <ChevronDown className="ml-1 h-4 w-4" />
              </button>
              {isDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                  <div className="py-1" role="menu" aria-orientation="vertical">
                    <Link
                      to="/login?role=student"
                      className="block px-4 py-2 text-sm text-road-700 hover:bg-drivewise-50"
                      role="menuitem"
                    >
                      Student Login
                    </Link>
                    <Link
                      to="/login?role=instructor"
                      className="block px-4 py-2 text-sm text-road-700 hover:bg-drivewise-50"
                      role="menuitem"
                    >
                      Instructor Login
                    </Link>
                    <Link
                      to="/login?role=admin"
                      className="block px-4 py-2 text-sm text-road-700 hover:bg-drivewise-50"
                      role="menuitem"
                    >
                      Admin Login
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <Button asChild className="bg-drivewise-600 hover:bg-drivewise-700">
              <Link to="/register">Register</Link>
            </Button>
          </div>
          <div className="flex md:hidden items-center">
            <button
              onClick={toggleMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-road-900 hover:text-drivewise-600 focus:outline-none"
            >
              {isMenuOpen ? (
                <X className="block h-6 w-6" aria-hidden="true" />
              ) : (
                <Menu className="block h-6 w-6" aria-hidden="true" />
              )}
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden">
          <div className="pt-2 pb-3 space-y-1">
            <Link
              to="/book-driving-lesson"
              className="block pl-3 pr-4 py-3 text-base font-medium text-white bg-green-600 hover:bg-green-700"
            >
              Book Driving Lesson
            </Link>
            <Link
              to="/"
              className="block pl-3 pr-4 py-2 text-base font-medium text-road-900 hover:text-drivewise-600 hover:bg-drivewise-50"
            >
              Home
            </Link>
            <Link
              to="/about"
              className="block pl-3 pr-4 py-2 text-base font-medium text-road-900 hover:text-drivewise-600 hover:bg-drivewise-50"
            >
              About Us
            </Link>
            <Link
              to="/instructors"
              className="block pl-3 pr-4 py-2 text-base font-medium text-road-900 hover:text-drivewise-600 hover:bg-drivewise-50"
            >
              Instructors
            </Link>
            <Link
              to="/student-gallery"
              className="block pl-3 pr-4 py-2 text-base font-medium text-road-900 hover:text-drivewise-600 hover:bg-drivewise-50"
            >
              Student Gallery
            </Link>
            <Link
              to="/faq"
              className="block pl-3 pr-4 py-2 text-base font-medium text-road-900 hover:text-drivewise-600 hover:bg-drivewise-50"
            >
              FAQ
            </Link>
            <Link
              to="/contact"
              className="block pl-3 pr-4 py-2 text-base font-medium text-road-900 hover:text-drivewise-600 hover:bg-drivewise-50"
            >
              Contact
            </Link>
          </div>
          <div className="pt-4 pb-3 border-t border-gray-200">
            <div className="space-y-1">
              <Link
                to="/login?role=student"
                className="block pl-3 pr-4 py-2 text-base font-medium text-road-900 hover:text-drivewise-600 hover:bg-drivewise-50"
              >
                Student Login
              </Link>
              <Link
                to="/login?role=instructor"
                className="block pl-3 pr-4 py-2 text-base font-medium text-road-900 hover:text-drivewise-600 hover:bg-drivewise-50"
              >
                Instructor Login
              </Link>
              <Link
                to="/login?role=admin"
                className="block pl-3 pr-4 py-2 text-base font-medium text-road-900 hover:text-drivewise-600 hover:bg-drivewise-50"
              >
                Admin Login
              </Link>
              <Link
                to="/register"
                className="block pl-3 pr-4 py-2 text-base font-medium text-drivewise-600 hover:text-drivewise-700 hover:bg-drivewise-50"
              >
                Register
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
